const ENVIRONMENT_LOCALHOST_API = {
    account: 'http://localhost:3000/account/v1',
    member: 'http://localhost:3001/member/v1',
    communication: 'http://localhost:3003/communication/v1',
    committee: 'http://localhost:3004/committee/v1',
    event: 'http://localhost:3002/event/v1',
    billing: 'http://localhost:3005/billing/v1',
    utilities: 'http://localhost:3006/utilities/v1',
    govt: 'http://localhost:3000/govt/v1',
    forms: 'http://localhost:3007/forms/v1',
    assets: 'http://localhost:3100',
    reporting: 'http://localhost:3010/reporting/v1',
    email: 'http://localhost:3009/email/v1',
    bean_counter: 'http://localhost:3011/bean_counter/v1',
    state_education: 'http://localhost:3012/state_education/v1'
};

const ENVIRONMENT_LOCALHOST_GENERAL_PROPERTIES = {
    production: false,
    localhost: true
};

const ENVIRONMENT_LOCALHOST_MEDIA_URL = 'https://tangilla-media-dev.s3.amazonaws.com';

const ENVIRONMENT_LOCALHOST_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

const ENVIRONMENT_MIGRATION_API = {
    account: 'https://migration-api.tangilla.com/account/v1',
    member: 'https://migration-api.tangilla.com/member/v1',
    communication: 'https://migration-api.tangilla.com/communication/v1',
    committee: 'https://migration-api.tangilla.com/committee/v1',
    event: 'https://migration-api.tangilla.com/event/v1',
    billing: 'https://migration-api.tangilla.com/billing/v1',
    utilities: 'https://migration-api.tangilla.com/utilities/v1',
    govt: 'https://migration-api.tangilla.com/govt/v1',
    forms: 'https://migration-api.tangilla.com/forms/v1',
    assets: 'https://migration-assets.tangilla.com',
    reporting: 'https://migration-api.tangilla.com/reporting/v1',
    email: 'https://migration-api.tangilla.com/email/v1',
    bean_counter: 'https://migration-api.tangilla.com/bean_counter/v1',
    state_education: 'https://migration-api.tangilla.com/state_education/v1'
};

const ENVIRONMENT_MIGRATION_GENERAL_PROPERTIES = {
    production: false,
    localhost: false,
};

const ENVIRONMENT_MIGRATION_MEDIA_URL = 'https://migration-media.tangilla.com';

const ENVIRONMENT_MIGRATION_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

const ENVIRONMENT_STAGING_API = {
    account: 'https://staging-api.tangilla.com/account/v1',
    member: 'https://staging-api.tangilla.com/member/v1',
    communication: 'https://staging-api.tangilla.com/communication/v1',
    committee: 'https://staging-api.tangilla.com/committee/v1',
    event: 'https://staging-api.tangilla.com/event/v1',
    billing: 'https://staging-api.tangilla.com/billing/v1',
    utilities: 'https://staging-api.tangilla.com/utilities/v1',
    govt: 'https://staging-api.tangilla.com/govt/v1',
    forms: 'https://staging-api.tangilla.com/forms/v1',
    assets: 'https://staging-assets.tangilla.com',
    reporting: 'https://staging-api.tangilla.com/reporting/v1',
    email: 'https://staging-api.tangilla.com/email/v1',
    bean_counter: 'https://staging-api.tangilla.com/bean_counter/v1',
    state_education: 'https://staging-api.tangilla.com/state_education/v1'
};

const ENVIRONMENT_STAGING_GENERAL_PROPERTIES = {
    production: false,
    localhost: false,
};

const ENVIRONMENT_STAGING_MEDIA_URL = 'https://staging-media.tangilla.com';

const ENVIRONMENT_STAGING_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

const ENVIRONMENT_QA_API = {
    account: 'https://qa-api.tangilla.com/account/v1',
    member: 'https://qa-api.tangilla.com/member/v1',
    communication: 'https://qa-api.tangilla.com/communication/v1',
    committee: 'https://qa-api.tangilla.com/committee/v1',
    event: 'https://qa-api.tangilla.com/event/v1',
    billing: 'https://qa-api.tangilla.com/billing/v1',
    utilities: 'https://qa-api.tangilla.com/utilities/v1',
    govt: 'https://qa-api.tangilla.com/govt/v1',
    forms: 'https://qa-api.tangilla.com/forms/v1',
    assets: 'https://qa-assets.tangilla.com',
    reporting: 'https://qa-api.tangilla.com/reporting/v1',
    email: 'https://qa-api.tangilla.com/email/v1',
    bean_counter: 'https://qa-api.tangilla.com/bean_counter/v1',
    state_education: 'https://qa-api.tangilla.com/state_education/v1'
};

const ENVIRONMENT_QA_GENERAL_PROPERTIES = {
    production: false,
    localhost: false,
};

const ENVIRONMENT_QA_MEDIA_URL = 'https://qa-media.tangilla.com';

const ENVIRONMENT_QA_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

const ENVIRONMENT_PRODUCTION_API = {
    account: 'https://api.tangilla.com/account/v1',
    member: 'https://api.tangilla.com/member/v1',
    communication: 'https://api.tangilla.com/communication/v1',
    committee: 'https://api.tangilla.com/committee/v1',
    event: 'https://api.tangilla.com/event/v1',
    billing: 'https://api.tangilla.com/billing/v1',
    utilities: 'https://api.tangilla.com/utilities/v1',
    govt: 'https://api.tangilla.com/govt/v1',
    forms: 'https://api.tangilla.com/forms/v1',
    assets: 'https://assets.tangilla.com',
    reporting: 'https://api.tangilla.com/reporting/v1',
    email: 'https://api.tangilla.com/email/v1',
    bean_counter: 'https://api.tangilla.com/bean_counter/v1',
    state_education: 'https://api.tangilla.com/state_education/v1'
};

const ENVIRONMENT_PRODUCTION_GENERAL_PROPERTIES = {
    production: true,
    localhost: false,
};

const ENVIRONMENT_PRODUCTION_MEDIA_URL = 'https://media.tangilla.com';

const ENVIRONMENT_PRODUCTION_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

const ENVIRONMENT_STATE_API = {
    account: 'https://state-api.tangilla.com/account/v1',
    member: 'https://state-api.tangilla.com/member/v1',
    communication: 'https://state-api.tangilla.com/communication/v1',
    committee: 'https://state-api.tangilla.com/committee/v1',
    event: 'https://state-api.tangilla.com/event/v1',
    billing: 'https://state-api.tangilla.com/billing/v1',
    utilities: 'https://state-api.tangilla.com/utilities/v1',
    govt: 'https://state-api.tangilla.com/govt/v1',
    forms: 'https://state-api.tangilla.com/forms/v1',
    assets: 'https://state-assets.tangilla.com',
    reporting: 'https://state-api.tangilla.com/reporting/v1',
    email: 'https://state-api.tangilla.com/email/v1',
    bean_counter: 'https://state-api.tangilla.com/bean_counter/v1',
    state_education: 'https://state-api.tangilla.com/state_education/v1'
};

const ENVIRONMENT_STATE_GENERAL_PROPERTIES = {
    production: false,
    localhost: false,
};

const ENVIRONMENT_STATE_MEDIA_URL = 'https://state-media.tangilla.com';

const ENVIRONMENT_STATE_DOCUMENTATION = {
    helpsSpotUrl: 'https://help.tangilla.com',
    helpsSpotEmail: 'help@tangilla.com',
    wikiUrl: 'https://docs.tangilla.com'
};

/**
 * Generated bundle index. Do not edit.
 */

export { ENVIRONMENT_LOCALHOST_API, ENVIRONMENT_LOCALHOST_DOCUMENTATION, ENVIRONMENT_LOCALHOST_GENERAL_PROPERTIES, ENVIRONMENT_LOCALHOST_MEDIA_URL, ENVIRONMENT_MIGRATION_API, ENVIRONMENT_MIGRATION_DOCUMENTATION, ENVIRONMENT_MIGRATION_GENERAL_PROPERTIES, ENVIRONMENT_MIGRATION_MEDIA_URL, ENVIRONMENT_PRODUCTION_API, ENVIRONMENT_PRODUCTION_DOCUMENTATION, ENVIRONMENT_PRODUCTION_GENERAL_PROPERTIES, ENVIRONMENT_PRODUCTION_MEDIA_URL, ENVIRONMENT_QA_API, ENVIRONMENT_QA_DOCUMENTATION, ENVIRONMENT_QA_GENERAL_PROPERTIES, ENVIRONMENT_QA_MEDIA_URL, ENVIRONMENT_STAGING_API, ENVIRONMENT_STAGING_DOCUMENTATION, ENVIRONMENT_STAGING_GENERAL_PROPERTIES, ENVIRONMENT_STAGING_MEDIA_URL, ENVIRONMENT_STATE_API, ENVIRONMENT_STATE_DOCUMENTATION, ENVIRONMENT_STATE_GENERAL_PROPERTIES, ENVIRONMENT_STATE_MEDIA_URL };
